import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ReactNode, useState } from "react";

import { getBrowserQueryClient, makeQueryClient } from "./queryClient";

interface QueryProviderProps {
  children: ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  // Server renders get a throwaway client per render — never shared across
  // requests; HydrationBoundary fills it from the loader's dehydrated state.
  // The browser keeps its singleton.
  const [client] = useState(() =>
    typeof document === "undefined"
      ? makeQueryClient()
      : getBrowserQueryClient(),
  );

  return (
    <QueryClientProvider client={client}>
      {children}
      {/* Hidden from automation: the floating button intercepts real clicks
          on bottom chrome, failing the browser smoke's actionability. */}
      {import.meta.env.DEV &&
        typeof navigator !== "undefined" &&
        !navigator.webdriver && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
